import { Outlet } from 'react-router-dom';
import Navbar from './Navbar'

const FranchiseLayout = () => {
  return (
    <>
      <Navbar />
      <div className="p-4 sm:ml-64 dark:bg-gray-900" style={{ paddingTop: '70px', minHeight: '100vh' }}>
        <Outlet />
      </div>
    </>
  );
};

export default FranchiseLayout;